import { getPathFromTags, getUrlFromPath } from '@/utils/routing';

export default ({ navigationTags, breadcrumbs = null }) => {
  let listElements;

  // use predefined breadcumbs or build breadcrumbs from navigationTags
  if (breadcrumbs) {
    listElements = breadcrumbs;
  } else {
    listElements = navigationTags.map((tag, i) => ({
      name: tag.title,
      path: getPathFromTags(navigationTags.slice(0, i + 1)),
    }));

    // add /wines/ breadcrumb
    if (listElements[0].path.startsWith('/wines/')) {
      listElements.unshift({
        name: 'Wines',
        path: '/wines/',
      });
    }
  }

  const data = {
    '@context': 'https://schema.org/',
    '@type': 'BreadcrumbList',
    itemListElement: listElements.map(({ name, path }, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name,
      item: getUrlFromPath(path),
    })),
  };

  return data;
};
